/**
 * Email Service
 * Sends email notifications to admin via EmailJS
 */

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL;

const sendEmail = async (subject, message, fromName = 'Zeppelindg Manager') => {
  console.log('EmailJS config:', { SERVICE_ID, TEMPLATE_ID, PUBLIC_KEY: !!PUBLIC_KEY, ADMIN_EMAIL });
  try {
    if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY || !ADMIN_EMAIL) {
      console.warn('EmailJS not configured — skipping email notification');
      return { success: false };
    }

    const response = await fetch('https://api.emailjs.com/api/v1.0/email/send', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        service_id: SERVICE_ID,
        template_id: TEMPLATE_ID,
        user_id: PUBLIC_KEY,
        template_params: {
          subject,
          message,
          from_name: fromName,
          reply_to: ADMIN_EMAIL,
        },
      }),
    });

    if (response.ok) {
      return { success: true };
    } else {
      const err = await response.text();
      console.error('EmailJS error:', err);
      return { success: false, error: err };
    }
  } catch (error) {
    console.error('Email send error:', error);
    return { success: false, error: error.message };
  }
};

export const emailNewMessage = async (clientName, messageContent, projectName) => {
  const subject = `New message from ${clientName}`;
  const message = `${clientName} sent a new message${projectName ? ` on project "${projectName}"` : ''}:\n\n"${messageContent}"\n\nLog in to reply: https://www.zeppelindg.app/admin/chat`;
  return sendEmail(subject, message, clientName);
};

export const emailNewProject = async (clientName, projectName) => {
  const subject = `New project created: ${projectName}`;
  const message = `${clientName} created a new project:\n\n"${projectName}"\n\nView project: https://www.zeppelindg.app/admin/projects`;
  return sendEmail(subject, message, clientName);
};

export const emailBudgetApproved = async (clientName, projectName, total) => {
  const subject = `Budget approved by ${clientName}`;
  const message = `${clientName} approved the budget for project "${projectName}"${total ? `\n\nTotal: ${total} €` : ''}.\n\nView budget: https://www.zeppelindg.app/admin/projects`;
  return sendEmail(subject, message, clientName);
};

export const emailFileUploaded = async (clientName, fileName, projectName, category) => {
  const subject = `New file uploaded by ${clientName}`;
  const message = `${clientName} uploaded a file${projectName ? ` to project "${projectName}"` : ''}:\n\n"${fileName}" (${category})\n\nView file: https://www.zeppelindg.app/admin/storage`;
  return sendEmail(subject, message, clientName);
};
